import {
  CheckboxCheckedIcon,
  CheckboxIcon,
  CheckboxIndeterminateIcon,
} from './customIcons';

import type { OverWritable } from '../../@types/settings';

export const checkbox: OverWritable = {
  MuiCheckbox: {
    defaultProps: {
      icon: <CheckboxIcon />,
      checkedIcon: <CheckboxCheckedIcon />,
      indeterminateIcon: <CheckboxIndeterminateIcon />,
    },

    styleOverrides: {
      root: ({ theme }) => ({
        padding: theme.spacing(1),
        '&.Mui-checked.Mui-disabled, &.Mui-disabled': {
          color: theme.palette.action.disabled,
        },
        '& .MuiSvgIcon-fontSizeMedium': {
          width: 24,
          height: 24,
        },
        '& .MuiSvgIcon-fontSizeSmall': {
          width: 20,
          height: 20,
        },
        svg: {
          fontSize: 24,
          '&[font-size=small]': {
            fontSize: 20,
          },
        },
      }),
    },
  },
};
